import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, CaseRegistrationByActorCodeController, CaseRegistrationByActorCodeRequest, CaseRecordSignatoryController, CaseRecordSignatoryRequest } from '../../../../../../../src/app/ncs/models/actor/actor';




@Component({
  selector: 'caserecord',
  templateUrl: './caserecord.component.html',
  styleUrls: ['./caserecord.component.scss']
})

export class CaserecordComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;

  public Date: Date;
  public FacilityCode: any;
  public RecordType: any;

  CurrentCaseRegistrationByActorCodeController: CaseRegistrationByActorCodeController[];
  PatientDetailsData: CaseRegistrationByActorCodeController;
  CurrentCaseRegistrationByActorCodeRequest: CaseRegistrationByActorCodeRequest;
  ActorCode: any;

  LoadCouple() {
    //alert("ScansData")
    this.CurrentCaseRegistrationByActorCodeRequest = new CaseRegistrationByActorCodeRequest();

    this.CurrentCaseRegistrationByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCaseRegistrationByActorCodeController();
  }

  GetCaseRegistrationByActorCodeController() {
    this.StartRefreshing();
    this.ActorCode = this.route.snapshot.paramMap.get('ActorCodeData');
    this.CurrentCaseRegistrationByActorCodeRequest.ActorCode = this.ActorCode;
    //this.CurrentCaseRegistrationByActorCodeRequest.FromDate = new Date();
    //this.CurrentCaseRegistrationByActorCodeRequest.ToDate = new Date();
    this.CurrentCaseRegistrationByActorCodeRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.CurrentCaseRegistrationByActorCodeRequest.ConditionalOperator = 10;
    this.actorservice.GetCaseRegistrationByActorCodeController(this.CurrentCaseRegistrationByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentCaseRegistrationByActorCodeController = this.ApiResData.Result;
          this.PatientDetailsData = this.CurrentCaseRegistrationByActorCodeController[0];
          this.stopRefreshing();
          this.LoadSign();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentCaseRecordSignatoryController: CaseRecordSignatoryController[];
  DoctorDetailsData: CaseRecordSignatoryController;
  CurrentCaseRecordSignatoryRequest: CaseRecordSignatoryRequest;



  LoadSign() {
    this.CurrentCaseRecordSignatoryRequest = new CaseRecordSignatoryRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentCaseRecordSignatoryRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.FacilityCode = this.route.snapshot.paramMap.get('FaclityCodeData');
    //this.RecordType = this.route.snapshot.paramMap.get('RecordTypeData');
    this.CurrentCaseRecordSignatoryRequest.FacilityCode = this.FacilityCode;
    //this.CurrentCaseRecordSignatoryRequest.RecordType = this.RecordType;

    this.GetCaseRecordSignatoryController();
  }
  GetCaseRecordSignatoryController() {
    this.StartRefreshing();


    this.actorservice.GetCaseRecordSignatoryController(this.CurrentCaseRecordSignatoryRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCaseRecordSignatoryController = this.ApiResData.Result;
          this.DoctorDetailsData = this.CurrentCaseRecordSignatoryController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.LoadScansData();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentOocyteQualityAssessmentByCodeController: OocyteQualityAssessmentByCodeController[];
  CurrentOocyteQualityAssessmentByCodeRequest: OocyteQualityAssessmentByCodeRequest;
  OocyteQualityCode: any;
  TreatmentCycleCode: any;

  LoadScansData() {
    //alert("ScansData")
    this.CurrentOocyteQualityAssessmentByCodeRequest = new OocyteQualityAssessmentByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    //this.OocyteQualityCode = this.route.snapshot.paramMap.get('OQACodedata');
    //this.TreatmentCycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.CurrentOocyteQualityAssessmentByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetOocyteQualityAssessmentByCodeController();
  }


  GetOocyteQualityAssessmentByCodeController() {
    this.StartRefreshing();
    this.CurrentOocyteQualityAssessmentByCodeRequest.SingleWellFollicleCode = this.TreatmentCycleCode;
    //this.CurrentOocyteQualityAssessmentByCodeRequest.SingleWellFollicleCode = this.OocyteQualityCode;
    //this.CurrentOocyteQualityAssessmentByCodeRequest.SingleWellFollicleCode = this.SelectedpatientDetails.TreatmentCycleCode;
    //this.CurrentOocyteQualityAssessmentByCodeRequest.ConditionalOperator = 10;

    //alert(this.FormattedCode);
    this.actorservice.GetOocyteQualityAssessmentByCodeController(this.CurrentOocyteQualityAssessmentByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentOocyteQualityAssessmentByCodeController = this.ApiResData.Result;
          //this.CurrentOocyteQualityAssessmentByCodeController = new Array<OocyteQualityAssessmentByCodeController>();
          //var data = this.ApiResData.Result as Array<OocyteQualityAssessmentByCodeController>;

          //data.forEach((v, i, a) => {
          //    this.CurrentOocyteQualityAssessmentByCodeController.push(v);
          //});
          //for (let index = 0; index < data.length; index++){
          //    //alert(data[index].SingleWellFollicleCoder);

          //    this.CurrentOocyteQualityAssessmentByCodeController.push(data[index]);
          //}
          //    this.FollicularOocyteInfo = this.CurrentOocyteQualityAssessmentByCodeController[0];
          //   alert(this.FollicularOocyteInfo.TreatmentCycle);
          //if (this.FollicularScanEndInfo.ScanDate != null) {
          //  var SValidFrom = new Date(this.FollicularScanEndInfo.ScanDate);
          //  if (SValidFrom.getFullYear() > 1900) {
          //    console.log('this.UpdateDate >1990');
          //    this.ScanDate = {

          //      year: SValidFrom.getFullYear(),
          //      month: SValidFrom.getMonth() + 1,
          //      day: SValidFrom.getDate()
          //    }
          //  }
          //}
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.printService.onDataReady();

          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {

    this.Date = new Date();
    this.LoadCouple();
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








